import { Scope } from '@/types/general.type';

const scopeList: Scope[] = [];

const scope = {
  state: {
    selectedScopeId: '',
    selectedScopeName: '',
    selectedScopeChildCounts: 0,
    isLastLevel: false,
    isDepartmentLevel: false,
    isFacultyLevel: false,
    startLevel: 0, /*
                   /* startLevel will override isLastLevel and isDepartmentLevel if startLevel > 0
                   /* startLevel = 1 --> University Level
                   /* startLevel = 2 --> Faculty Level
                   /* ...
                    */
    scopeList,
    openOnClick: false,
  },
  mutations: {
    resetScope(state) {
      state.scopeList = [];
      state.selectedScopeId = null;
      state.selectedScopeName = null;
      state.selectedScopeChildCounts = null;
      state.isLastLevel = false;
      state.isDepartmentLevel = false;
      state.isFacultyLevel = false;
      state.startLevel = 0;
    },
    scopeList(state, listScope: Scope[]) {
      state.scopeList = listScope;
    },
    selectScope(state, payload) {
      if (payload.scope.name) {
        state.selectedScopeId = payload.scope.id;
        state.selectedScopeName = payload.scope.name;
        state.selectedScopeChildCounts = payload.scope.childCounts;
      } else {
        state.selectedScopeId = null;
        state.selectedScopeName = null;
        state.selectedScopeChildCounts = null;
      }
    },
    setTreeLastLevel(state, isLastLevel) {
      state.isLastLevel = isLastLevel;
    },
    setTreeDepartmentLevel(state, isDepartmentLevel) {
      state.isDepartmentLevel = isDepartmentLevel;
    },
    setTreeStartLevel(state, startLevel) {
      state.startLevel = startLevel;
    },
    setTreeOpenOnClick(state, openOnClick) {
      state.openOnClick = openOnClick;
    },
    setTreeFacultyLevel(state, isFacultyLevel) {
      state.isFacultyLevel = isFacultyLevel;
    },

  },
};

export default scope;
